import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a drag indicator icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DriverIcon width={12} />
 */
const DriverIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M21.71,16.63C21.23,16.24,20.64,16,20,16c-0.87,0-1.65,0.44-2.19,1.13C16.24,15.8,14.22,15,12,15s-4.24,0.8-5.81,2.13
          C5.65,16.44,4.87,16,4,16c-0.64,0-1.23,0.24-1.71,0.63c0.71-1.8,2.75-3.3,5.49-4.07C8.95,13.46,10.41,14,12,14s3.05-0.54,4.23-1.43
          C18.96,13.34,21.01,14.83,21.71,16.63z M20,17c-1.1,0-2,1.12-2,2.5s0.9,2.5,2,2.5s2-1.12,2-2.5S21.1,17,20,17 M4,17
          c-1.1,0-2,1.12-2,2.5S2.9,22,4,22s2-1.12,2-2.5S5.1,17,4,17 M12,2C9.24,2,7,4.24,7,7s2.24,5,5,5s5-2.24,5-5S14.76,2,12,2 M17,19.5
          c0-0.22,0.02-0.43,0.06-0.64C15.78,17.71,13.99,17,12,17s-3.78,0.71-5.06,1.86C6.98,19.07,7,19.28,7,19.5c0,0.62-0.15,1.2-0.39,1.7
          L9,22h0.06c0.28-1.14,1.49-2,2.94-2s2.66,0.86,2.94,2H15l2.39-0.8C17.15,20.7,17,20.12,17,19.5z"
        />
    </SvgIcon>
)

DriverIcon.defaultProps = defaultProps

export { DriverIcon }
